import React from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Icon, Row, Text } from '@evertel/web/ui'
import { useContext } from 'react'
import { MessageWallContext } from '@evertel/message'

export type ToolBarOption = 'link'|'emoji-picker'|'urgent'|'attach'|'bold'|'italic'|'urgent'|'list'|'ol-list'|'block'|'strike'|'attach'

interface CreateMessageToolbarProps {
    isUrgent: boolean
    onClickOption: (option: ToolBarOption) => void
}

const CreateMessageToolbar: React.FC<CreateMessageToolbarProps> = observer(({
    isUrgent,
    onClickOption
}) => {

    const { emojiPickerState } = useContext(MessageWallContext)

    return (
        <Row valign="center" >
            <Button
                color="muted"
                ghost
                className="py-1 my-1"
                aria-label="Attach"
                onClick={() => onClickOption('attach')}
                data-tooltip="Upload file"
                data-tooltip-id="attach"
                data-tooltip-pos="top"
            >
                <Icon
                    name="paperclip"
                    //color={(showImgUploader || hasMedia()) ? 'secondary' : null}
                    size={18}
                    aria-hidden
                />
            </Button>
            <Button
                color="muted"
                ghost
                className="py-1 my-1"
                aria-label="Emoji Picker"
                onClick={() => onClickOption('emoji-picker')}
                data-tooltip={(!emojiPickerState.visible) ? 'Emoji' : null}
                data-tooltip-id="emoji"
                data-tooltip-pos="top"
            >
                <Icon
                    id="emoji-bttn"
                    name="smile"
                    size={18}
                    color={(emojiPickerState.visible) ? 'warning' : null}
                    aria-hidden
                />
            </Button>
            <Button
                color="muted"
                ghost
                className="py-1 my-1"
                aria-label={(isUrgent?'Unmark':'Mark') + 'Urgent'}
                onClick={() => onClickOption('urgent')}
                data-tooltip="Mark as Urgent"
                data-tooltip-id="urgent"
                data-tooltip-pos="top"
            >
                <Icon
                    name="exclamation-triangle"
                    color={(isUrgent) ? 'danger' : null}
                    size={18}
                    onClick={() => onClickOption('urgent')}
                    aria-hidden
                />
            </Button>
            {(isUrgent) &&
                <Text
                    size="small"
                    color="danger"
                    className="ps-1">
                    Urgent
                </Text>
            }
        </Row>
    )
})

export { CreateMessageToolbar }
